import React, { useEffect, useState, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import ActionButton from '../../component/action-button';
import ItemManagement from '../../outlet/outlet-container';
import ReactPaginate from 'react-paginate';
import { GetAllDeHub } from '../../api/apiService';
import { connect } from 'react-redux';
import { loader } from '../../Actions';
import store from '../../store';

const mapStateToProps = store => ({
  loaderDisplay: store.loaderDisplay,
});

const DeHubsList = () => {
  const history = useHistory();
  const [hubs, setHubs] = useState([]);
  const [countHub, setCountHub] = useState({});
  const [countPage, setCountPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const getOutList = useCallback(async (pageNo = 1, searchTerm) => {
    try {
      store.dispatch(loader(true));
      const res = await GetAllDeHub(pageNo, searchTerm);
      setHubs(res.data.data);
      setCountHub(res.data);
      setCountPage(res.data?.pageInfo?.totalPages || 1);
    } catch (err) {
      console.error(err);
    } finally {
      store.dispatch(loader(false));
    }
  }, []);

  useEffect(() => {
    getOutList(1);
  }, [getOutList]);

  const hubPageFunc = i => {
    getOutList(i.selected + 1);
  };
  useEffect(() => {
    if (searchTerm.length >= 3) {
      getOutList(1,searchTerm);
    }
  }, [getOutList, searchTerm]);

  return (
    <ItemManagement demoPathName="/hubs" hubPathName="Hub">
      <div className="mt-4 d-sm-flex justify-content-between">
        <div
          className="d-flex align-items-center justify-content-between notifi-box cursor-pointer"
          style={{ backgroundColor: 'blue' }}
          onClick={() => history.push('/daily-essentials/hubs/create')}
        >
          <div>
            <div className="icon-container hub-icon-1">
              <i className="demo-icon icon-add font-20" style={{ color: '#fff' }}>&#xe802;</i>
            </div>
          </div>
          <div className="text-center">
            <div className="title" style={{ color: '#fff' }}>Add</div>
            <div className="sub-title" style={{ color: '#fff' }}>New Hub</div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between notifi-box" style={{ background: "#e2fffa", color: "#3ee4ff" }}>
          <div><i className="demo-icon icon-add-ons font-25">&#xe803;</i></div>
          <div className="text-center">
            <div className="title">{countHub.totalHubs}</div>
            <div className="sub-title">Total Hubs</div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between notifi-box" style={{ background: "#fbe0be", color: "#fa9417" }}>
          <div><i className="demo-icon icon-add-ons font-20">&#xe803;</i></div>
          <div className="text-center">
            <div className="title">{countHub.countDeactive}</div>
            <div className="sub-title">Unpublish Hubs</div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between notifi-box" style={{ background: "#d5fefb", color: "#8edd89" }}>
          <div><i className="demo-icon icon-add-ons font-25">&#xe803;</i></div>
          <div className="text-center">
            <div className="title">000</div>
            <div className="sub-title">Publish Hubs</div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between notifi-box" style={{ background: "#d0fcd1", color: "#53f957" }}>
          <div><i className="demo-icon icon-add-ons font-25">&#xe803;</i></div>
          <div className="text-center">
            <div className="title">000</div>
            <div className="sub-title">Open Hubs</div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between notifi-box" style={{ background: "#fbd4c2", color: "#fe590d" }}>
          <div><i className="demo-icon icon-add-ons font-25">&#xe803;</i></div>
          <div className="text-center">
            <div className="title">000</div>
            <div className="sub-title">Closed Hubs</div>
          </div>
        </div>
      </div>

      <div className="category-container my-4">
        <div className="table-search">
          <div className="search-container">
            <input
              onChange={(e) => setSearchTerm(e.target.value)}
              type="search"
              placeholder="Search.."
              name="search"
              autoFocus
            />
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-hover text-capitalize">
            <thead>
              <tr>
                <th>Image</th>
                <th>Store Name</th>
                <th>Store Address</th>
                <th>Owner</th>
                <th className="text-center">Complimantory</th>
                <th className="text-center">Type</th>
                <th>Open</th>
                <th>Close</th>
                <th>Breaking Time</th>
                <th className="text-center">Publish / Unpublish</th>
                <th className="text-center">status</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {hubs.map(item => (
                <tr key={item._id}>
                  <td>
                    <img
                      className="img-fluid table-img"
                      src={item.De_Hub_images ? item.De_Hub_images : "/assate/images/store-logo.png"}
                      alt=""
                    />
                  </td>
                  <td>
                    <Link to={`/daily-essentials/hubs/single-hub?hubId=${item._id}`}>{item.hub_name}</Link><br />
                    <b className="font-12">
                      {item.offer
                        ? `Offer ${item.offer.percentage
                          ? `${item.offer.amount}%`
                          : `₹${item.offer.amount}`}`
                        : ""}
                    </b>
                  </td>
                  <td style={{ width: "26%" }}>
                    <div className="table-address">{item.address_details.address}</div>
                    <b className="font-12">{item.address_details.pincode}</b>
                  </td>
                  <td>{item.owner.full_name}<br /><b style={{ color: "green" }}>{item.owner.mobile}</b></td>
                  <td className="text-center">
                    <b className="font-12">{!item.complementary || item.complementary === "null" ? "" : item.complementary.name}</b>
                  </td>
                  <td className="text-center">
                    <b className="font-12" style={{ color: "#000", textTransform: "uppercase" }}>{!item.resturentType || item.resturentType === "null" ? "" : item.resturentType}</b>
                  </td>
                  <td>{item.opening_time}</td>
                  <td>{item.closing_time}</td>
                  <td style={{ color: "#076868" }}>{item.break_start && item.break_end ? item.break_start + "-" + item.break_end : ""}</td>
                  <td className="text-center">
                    {item.isActive ? (
                      <span className="badge badge-success">Publish</span>
                    ) : (
                      <span className="badge badge-danger">Unpublish</span>
                    )}
                  </td>
                  <td className="text-center">
                    {item.isOpen ? (
                      <span className="badge badge-success">Open</span>
                    ) : (
                      <span className="badge badge-danger">closed</span>
                    )}
                  </td>
                  <td>
                    <span className="user-table-auction-item">
                      <Link to={`/daily-essentials/hubs/update?hubId=${item._id}`}>
                        <ActionButton>
                          <i className="demo-icon icon-edit" style={{ color: 'blue' }}>&#xe80f;</i>
                        </ActionButton>
                      </Link>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <ReactPaginate
          previousLabel={'<<'}
          nextLabel={'>>'}
          breakLabel={'...'}
          breakClassName={'break-me'}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          pageCount={countPage}
          onPageChange={hubPageFunc}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
      </div>
    </ItemManagement>
  );
};

export default connect(mapStateToProps)(DeHubsList);
